<template>
    <div>
        <eco-header :step_num="7" />
        <b-row>
            <b-col>
                <b-spinner v-if="spinner" small label="Отправка файла..." variant="success"></b-spinner>
                <template v-if="done">
                    <h3>Ваша заявка успешно сохранена!</h3>
                    <hr />
                    <p>На указанный вами электронный адрес ({{ email }}) направлена копия данной заявки.
                    <br/>В ближайшее время она будет обработана и с вами свяжутся специалисты РО "Эко-Сити". 
                    <br/>Идентификационный номер заявки: {{ uuid }}.
                    </p>
                    <hr />
                    <h3>Спасибо!</h3>
                </template>
            </b-col>
        </b-row>
        <eco-footer :step_num="7" />
    </div>
</template>

<script>
export default {
    data() {
        return {
            spinner: false,
            done: false,
            error: false,
            message: '',
            email: '',
            uuid: ''
        }
    },
    methods:{

    },
    computed:{

    },
    mounted() {
        this.spinner = true
        let company = this.$store.getters.COMPANY
        company.status = true
        this.email = `${company.contacts.email}`
        this.uuid = `${this.$store.getters.UUID}`
        this.$store.dispatch('COMPANY', company)
        this.$store.dispatch('REMEMBER_COMPANY')
        .then(res => {
            if(res === true) {
                this.done = true
                this.$cookies.remove('request_uuid')
                this.$store.commit('UUID', null)
				this.$store.commit('COMPANY', null)
            } else {
                this.error = true
            }
            this.spinner = false
        })
        .catch(err => window.$showError(err))
    }
}
</script>